// @flow
import { ObjectType } from '@types/misc';

type StateType = {
  style: Array<string>,
  gender: Array<string>,
  design: Array<string>,
  metal: Array<string>,
  price?: Array<number>,
  sort: string,
  matchingSettingsOnly: boolean,
  contour: boolean
};

const initialState = {
  style: [],
  gender: [],
  design: [],
  metal: [],
  price: undefined,
  sort: 'asc',
  contour: false
};

export default function bandSearchFilters(
  state: StateType = initialState,
  action: ObjectType
): ObjectType {
  switch (action.type) {
    case 'TOGGLE_BAND_FILTER':
      const { filterName, group } = action.payload;
      const currentFiltersInGroup = [...state[group]];
      let newFilters;

      const indexOfItem = currentFiltersInGroup.indexOf(filterName);

      if (indexOfItem >= 0) {
        currentFiltersInGroup.splice(indexOfItem, 1);
        newFilters = currentFiltersInGroup;
      } else {
        newFilters = [...currentFiltersInGroup, filterName];
      }

      return {
        ...state,
        [group]: newFilters
      };

    case 'SET_BAND_FILTER':
      return {
        ...state,
        [action.payload.filterName]: action.payload.value
      };

    case 'RESET_BAND_FILTERS':
      return {
        ...initialState,
        ...action.filters
      };

    default:
      return state;
  }
}
